/*
 *
 * Do not edit directly
 * Generated on Fri, 14 Feb 2025 18:58:13 GMT
 *
 */


const theme = {
  appearances: {
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    inactive: {
      description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
      type: 'state',
      values: [ true ]
    },
    inverse: { type: 'variant', values: [ true ] },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    },
    selected: {
      description: 'Applies while an interactive component is the currently selected one in a set of states or components, for example a button in a `ButtonGroup`.',
      type: 'state',
      values: [ true ]
    }
  },
  rules: [
    {
      if: { hover: true },
      tokens: {
        borderBottomColor: '#394056',
        borderBottomWidth: 2,
        color: '#394056'
      }
    },
    {
      if: { focus: true },
      tokens: {
        borderBottomColor: '#394056',
        borderBottomWidth: 4,
        color: '#394056'
      }
    },
    {
      if: { pressed: true },
      tokens: {
        borderBottomColor: '#f39d80',
        borderBottomWidth: 2,
        color: '#f6b5a0'
      }
    },
    {
      if: { focus: true, pressed: true },
      tokens: { borderBottomWidth: 4 }
    },
    {
      if: { inactive: true },
      tokens: {
        borderBottomColor: '#394056',
        borderBottomWidth: 4,
        color: '#394056'
      }
    },
    {
      if: { selected: true },
      tokens: {
        borderBottomColor: '#f39d80',
        borderBottomWidth: 4,
        color: '#394056'
      }
    },
    { if: { inverse: true }, tokens: { color: '#f9f2dd' } },
    {
      if: { hover: true, inverse: true },
      tokens: {
        borderBottomColor: '#f9cebf',
        borderBottomWidth: 2,
        color: '#f9cebf'
      }
    },
    {
      if: { focus: true, inverse: true },
      tokens: {
        borderBottomColor: '#f9f2dd',
        borderBottomWidth: 4,
        color: '#f9f2dd'
      }
    },
    {
      if: { inverse: true, pressed: true },
      tokens: {
        borderBottomColor: '#f39d80',
        borderBottomWidth: 4,
        color: '#f39d80'
      }
    },
    {
      if: { inactive: true, inverse: true },
      tokens: {
        borderBottomColor: '#394056',
        borderBottomWidth: 4,
        color: '#394056'
      }
    },
    {
      if: { inverse: true, selected: true },
      tokens: {
        borderBottomColor: '#f39d80',
        borderBottomWidth: 4,
        color: '#f9cebf'
      }
    }
  ],
  tokens: {
    alignItems: 'flex-start',
    borderBottomColor: 'transparent',
    borderBottomStyle: 'solid',
    borderBottomWidth: 0,
    color: '#394056',
    flex: 1,
    fontName: 'SofiaPro',
    fontScaleCap: 64,
    fontSize: 16,
    fontWeight: '700',
    justifyContent: 'flex-start',
    letterSpacing: 0,
    lineHeight: 1.5,
    paddingBottom: 16,
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 0
  }
}
export default theme
